module.exports = __webpack_public_path__ + "img/no-data.e9850f2b.svg";